import React from "react";

const steps = [
  {
    pics: "./assets/profile.svg",
    title: "Sign Up",
    description: "Create a business account in minutes.",
  },
  {
    pics: "./assets/verify.svg",
    title: "Verify your Business",
    description: "Upload necessary details.",
  },
  {
    pics: "./assets/card-coin.svg",
    title: "Start Transacting",
    description: "Send invoices, make payments, and access financial tools.",
  },
  {
    pics: "./assets/status-up.svg",
    title: "Grow Your Business",
    description: "Get insights, loans, and advanced payment solutions.",
  },
];

const SectionFour = () => {
  return (
    <div className="bg-[#FCFCFC] px-6 py-5 md:px-16 md:py-10 flex flex-col md:flex-row gap-y-6 md:gap-y-10 lg:gap-x-10 xl:gap-x-0">
      <div className=" w-full md:w-[50%]  ">
          <img src={"/assets/user.svg"} alt="user-image" className="w-full  h-[320px] lg:h-[380px] xl:h-[420px]" fill />
      </div>

      <div className="  w-full md:w-[50%]   ">
        <p className="text-sm md:text-xl lg:text-2xl xl:text-2xl font-bold ">
          How it works
        </p>
        <div className="flex flex-col gap-2 mt-5">
          {steps.map((step, index) => (
            <div key={index} className="flex gap-4 ">
              <div className="flex flex-col items-center">
                <img
                  src={step.pics}
                  alt="profile-image"
                  className="h-6 w-6  lg:h-8 lg:w-8"
                />
                {index !== steps.length - 1 && ( // Don't show line after the last step
                  <div className="border-r border-[#32AE4C] w-[2px] h-8 md:h-9 lg:h-10" />
                )}
              </div>
              <div className="flex flex-col gap-1 md:gap-3 lg:gap-2">
                <p className="text-sm md:text-base lg:text-xl font-semibold">
                  {step.title}
                </p>
                <p className="text-xs md:text-sm lg:text-sm xl:text-base text-gray-500">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionFour;
